import {PortfolioType} from "../../../portfolio/models/Portfolio";
import {isTmcOrder, OrderRecord, TmcLeg} from "../OrderRecord";
import {AccountId} from "../../../account/types/AccountRecord";
import {OffsetDateTime} from "../../../pseudo-types/DateTypes";

export type SimulatedOrderRecords = ReadonlyArray<SimulatedOrderRecord>;

export type SimulatedOrderId = number & { __simulatedId: number };

export interface SimulatedOrderRecord extends OrderRecord {
    readonly id: SimulatedOrderId;
    readonly portfolioType: PortfolioType.SIMULATED | PortfolioType.SCRATCH;
    readonly portfolioId: AccountId;
    readonly accountName: string;
    readonly externalRef: string | null;
    readonly description: string;
    readonly completed: OffsetDateTime | null;
}

export interface SimulatedTmcOrderRecord extends SimulatedOrderRecord {
    readonly legs: ReadonlyArray<TmcLeg>;
}

export function isSimulatedOrder(record: OrderRecord): record is SimulatedOrderRecord {
    return "id" in record;
}

export function isSimulatedTmcOrder(record: OrderRecord): record is SimulatedTmcOrderRecord {
    return isSimulatedOrder(record) && isTmcOrder(record);
}
